import React, { useContext } from "react";
import "../styles/StaticPage.css";
import { StaticPagesContext } from "../contexts/StaticPagesContext";


export default function Impressum() {
  const { getPage, loading, error } = useContext(StaticPagesContext);

  const page = getPage("sicherheitsinfo");

  if (loading) {
    return (
      <div className="impressum-wrapper">
        <div
          style={{
            width: "1000px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            margin: "0 auto",
          }}
        >
          <p>Lade Inhalte…</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="agb-wrapper">
        <div style={{ width: "1000px", margin: "0 auto" }}>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  if (!page) {
    return (
      <div className="agb-wrapper">
        <div style={{ width: "1000px", margin: "0 auto" }}>
          <p>Seite nicht gefunden.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="agb-wrapper">
      <div>
        {page.title ? (
          <div className="static-page-title">
            <h1>{page.title}</h1>
          </div>
        ) : null}

        {page.subtitle ? (
          <div className="static-page-subtitle">
            <p>{page.subtitle}</p>
          </div>
        ) : null}

        <div
          className="static-page-content"
          dangerouslySetInnerHTML={{ __html: page.content || "" }}
        />
      </div>
    </div>
  );
}
